import React, { useState, useEffect } from 'react';
import { Row, Col, Radio, Tooltip } from 'antd';

const Choices = ({
  answer,
  options,
  index,
  changeAnswerValue,
  withTooltip = false,
  ...rest
}) => {
  const tagsData = ['1', '2', '3'].map((item, idx) => {
    let text = options[item - 1].text,
      tooltipContent = null;

    if (withTooltip) {
      const arr = text.split('(');
      text = arr[0];
      tooltipContent = String(arr[1] || '').replace(')', '');

      tooltipContent =
        tooltipContent.length > 0
          ? tooltipContent.charAt(0).toUpperCase() + tooltipContent.substring(1)
          : tooltipContent;
    }

    return {
      text,
      index: item,
      tooltipContent,
    };
  });

  const [selectedTag, setSelectedTag] = useState(answer);
  useEffect(() => {
    setSelectedTag(answer);
  }, [answer]);
  const handleChange = (e) => {
    const v = e.target.value;
    changeAnswerValue([v]);
    setSelectedTag(v);
  };
  const needSplit = (tag) => {
    if (tag.indexOf('/') > -1) {
      return true;
    }
  };
  return (
    <>
      <Radio.Group value={selectedTag} onChange={handleChange}>
        <Row gutter={[20, 16]} className="big-choice-button">
          {tagsData.map((tag, idx) => (
            <Col span={8} key={idx}>
              <Tooltip
                title={tag.tooltipContent}
                overlayStyle={{ width: idx === 0 ? 200 : 250 }}
              >
                <div className="button-wrapper">
                  <Radio.Button
                    value={tag.index}
                    key={tag.text}
                    // className="level-of-integration-radio"
                  >
                    {needSplit(tag.text) ? (
                      <div className="split-text-button">
                        <span> {`${tag.text.split('/')[0]}`}/</span>
                        <span>{tag.text.split('/')[1]}</span>
                      </div>
                    ) : (
                      tag.text
                    )}
                  </Radio.Button>
                </div>
              </Tooltip>
            </Col>
          ))}{' '}
        </Row>
      </Radio.Group>
    </>
  );
};

const BIG = 'bigger';
const MID = 'regular';
const SML = 'smaller';

export const EulerChartWithChoices = (props) => {
  const { answer } = props;

  const getSizes = (_ans) => {
    if (_ans === '1') {
      return [BIG, SML];
    }

    if (_ans === '3') {
      return [SML, BIG];
    }
    return [MID, MID];
  };

  const sizes = getSizes(answer);

  return (
    <div className="euler-choices">
      <div className="euler-chart">
        <div className={`${sizes[0]} circle-area buyer`}>Buyer</div>
        <div className={`${sizes[1]} circle-area target`}>Target</div>
      </div>
      <Choices {...props} />
    </div>
  );
};

export const ChoicesWithTooltips = (props) => (
  <Choices withTooltip {...props} />
);

export default Choices;
